import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ChannelSchema, PricingPlanSchema, UserSchema } from 'types';
import { EMPTY_USER } from 'utils';

export type MembershipChannelsType = Record<string, string>;

export type ProfileState = {
  membershipPricingPlan: PricingPlanSchema | null;
  membershipChannels: MembershipChannelsType;
  subscribedChannels: ChannelSchema[];
  user: UserSchema;
};

const initialState: ProfileState = {
  membershipPricingPlan: null,
  membershipChannels: {},
  subscribedChannels: [],
  user: EMPTY_USER
};

export const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    setChannels: (state, action: PayloadAction<ChannelSchema[]>) => {
      // eslint-disable-next-line no-param-reassign
      state.subscribedChannels = action.payload;
    },
    setUser: (state, action: PayloadAction<UserSchema>) => ({
      ...state,
      user: action.payload,
      membershipChannels: action.payload.membershipChannels.reduce(
        (prev, current) => ({ ...prev, [current]: true }),
        {}
      )
    }),
    setChannelName: (state, action: PayloadAction<{ channelName: string }>) => ({
      ...state,
      user: {
        ...state.user,
        channelName: action.payload.channelName
      }
    }),
    addChannel: (state, action: PayloadAction<ChannelSchema>) => ({
      ...state,
      subscribedChannels: [...state.subscribedChannels, action.payload]
    }),
    removeChannel: (state, action: PayloadAction<{ channelId: string }>) => ({
      ...state,
      subscribedChannels: state.subscribedChannels.filter(channel => channel.id !== action.payload.channelId)
    }),
    setMembershipPricingPlan: (state, action: PayloadAction<PricingPlanSchema>) => ({
      ...state,
      membershipPricingPlan: action.payload
    }),
    resetProfile: () => initialState
  }
});

export const profileReducer = profileSlice.reducer;
export const profileActions = {
  ...profileSlice.actions
};
